import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import List from "../components/List";
import styles from "../assets/css/InUser.module.css";
import HistoryData from "../components/HistoryData";
import { BASE_URL } from "../constants/constants";

const InUser = () => {
  const [user, setUser] = useState({});
  const [trips, setTrips] = useState([]);
  const [isDeactivated, setIsDeactivated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedTrip, setSelectedTrip] = useState(null);
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const headers = {
    Authorization:
      `Bearer ${token}`,
  };

  const getUser = (id) => {
    axios
      .get(`${BASE_URL}/v0/users/${id}/profile`, { headers })
      .then((response) => {
        setUser(response.data.result);
        setIsDeactivated(!response.data.result);
      })
      .catch((error) => {
        console.error("Error fetching user data!", error);
      });
  };

  const getUserTrips = (userId) => {
    axios
      .get(`${BASE_URL}/v0/users/${userId}/trips`, { headers })
      .then((response) => {
        setTrips(response.data.result);
      })
      .catch((error) => {
        console.error("Error fetching user trips!", error);
      });
  };

  const openTripModal = (userId, tripId) => {
    axios
      .get(`${BASE_URL}/v0/users/${userId}/trips/${tripId}`, { headers })
      .then((response) => {
        setSelectedTrip(response.data.result);
        setIsModalOpen(true);
      })
      .catch((error) => {
        console.error("Error fetching trip data!", error);
      });
  };

  const deactivateUser = () => {
    const userId = user.id;
    if (!userId) return;

    axios
      .post(`${BASE_URL}/v0/users/${userId}/activate`, null, {
        headers,
        params: {
          status: false,
        },
      })
      .then((response) => {
        setIsDeactivated(true);
        alert(
          `Пользователь ${
            user.firstName || "Пользователь"
          } успешно деактивирован.`
        );
        navigate("/");
      })
      .catch((error) => {
        console.error("Error deactivating user!", error);
      });
  };

  const activateUser = () => {
    const userId = user.id;
    if (!userId) return;

    axios
      .post(`${BASE_URL}/v0/users/${userId}/activate`, null, {
        headers,
        params: {
          status: true,
        },
      })
      .then((response) => {
        setIsDeactivated(false);
        alert(
          `Пользователь ${
            user.firstName || "Пользователь"
          } успешно активирован.`
        );
      })
      .catch((error) => {
        console.error("Error activating user!", error);
      });
  };

  useEffect(() => {
    if (id) {
      getUser(id);
      getUserTrips(id);
    }
  }, [id]);

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div onClick={() => navigate("/")} className={styles.text}>
              Пользователи
            </div>
            <img
              className={styles.nexticon}
              src="/images/next.svg"
              alt="next icon"
            />
            <div className={styles.text1}>
              {user.firstName || "Пользователь"}
            </div>
          </div>
          <div className={styles.container2}>
            <div className={styles.box1}>
              <div className={styles.text2}>
                {user.firstName || "Пользователь"}
              </div>
              <button
                className={
                  isDeactivated ? styles.activatebtn : styles.deactivatebtn
                }
                onClick={isDeactivated ? activateUser : deactivateUser}
              >
                {isDeactivated ? "Активировать" : "Деактивировать"}
              </button>
            </div>
            <div className={styles.box3}>
              <div className={styles.box4}>
                <img
                  className={styles.boxicons}
                  src="/images/rating.svg"
                  alt="rate icon"
                />
                <div className={styles.boxitems}>{user.rating}</div>
              </div>
              <div className={styles.box4}>
                <img
                  className={styles.boxicons}
                  src="/images/time.svg"
                  alt="time icon"
                />
                <div className={styles.boxitems}>{new Date(user.createdAt).toLocaleDateString()}</div>
              </div>
            </div>
            <div className={styles.boxuser}>
              <img
                className={styles.image}
                src={
                  user.avatarImageUrl && user.avatarImageUrl.trim() !== ""
                    ? `${BASE_URL}/v0${user.avatarImageUrl}`
                    : "/images/users.svg"
                }
                alt="User avatar"
              />
              <div className={styles.box5}>
                <div className={styles.text3}>Данные пользователя</div>
                <div className={styles.box6}>
                  <div className={styles.type}>Имя:</div>
                  <div className={styles.type1}>
                    {user.firstName || "Не указано"}
                  </div>
                </div>
                <div className={styles.box6}>
                  <div className={styles.type}>Фамилия:</div>
                  <div className={styles.type1}>
                    {user.lastName || "Не указано"}
                  </div>
                </div>
                <div className={styles.box6}>
                  <div className={styles.type}>Номер телефона:</div>
                  <div className={styles.type1}>{user.phoneNumber}</div>
                </div>
                <div className={styles.box6}>
                  <div className={styles.type}>Дата регистрации:</div>
                  <div className={styles.type1}>{new Date(user.createdAt).toLocaleDateString()}</div>
                </div>
                <div className={styles.box6}>
                  <div className={styles.type}>Дата обновления:</div>
                  <div className={styles.type1}>{user.updatedAt || "-"}</div>
                </div>
                <div className={styles.box6}>
                  <div className={styles.type}>Дата удаления:</div>
                  <div className={styles.type1}>{user.deletedAt || "-"}</div>
                </div>
              </div>
            </div>
            <div className={styles.box2}>
              <button
                onClick={() => navigate("/")}
                className={styles.deletebtn}
              >
                Назад
              </button>
            </div>
            <div className={styles.container3}>
              <div className={styles.orderhistory}>История заказов</div>
              {trips.length > 0 ? (
                trips.map((trip) => (
                  <div key={trip.tripId} className={styles.block}>
                    <div className={styles.box7}>
                      <div className={styles.box8}>
                        <div className={styles.drivetime}>
                          Поездка в {trip.createdAt.split(" ")[1]},
                        </div>
                        <div className={styles.date}>
                          {new Date(trip.createdAt).toLocaleDateString(
                            "ru-RU",
                            { day: "numeric", month: "long" }
                          )}
                        </div>
                      </div>
                      <div className={styles.box9}>
                        <div className={styles.price}>{trip.cost} ₸,</div>
                        <div className={styles.address}>{trip.endAddress}</div>
                      </div>
                    </div>
                    <img
                      onClick={() => openTripModal(id, trip.tripId)}
                      className={styles.righticon}
                      src="/images/arrowright.svg"
                      alt="next icon"
                    />
                  </div>
                ))
              ) : (
                <div className={styles.noTrips}>Нет поездок</div>
              )}
            </div>
          </div>
        </div>
        {isModalOpen && (
          <HistoryData
            trip={selectedTrip}
            closeModal={() => setIsModalOpen(false)}
          />
        )}
      </div>
    </div>
  );
};

export default InUser;
